

































































































































import { Component, Vue } from 'vue-property-decorator'
import Instruction from '@/components/Instruction.vue'
import * as timer from './../utils/timer'
import * as ArrayUtils from './../utils/array-utils'
import SpriteAnimator from '@/components/SpriteAnimator.vue'
import InputField from '@/components/InputField.vue'
import FracField from '@/components/FracField.vue'

@Component({
  components: {
    Instruction,
    SpriteAnimator,
    InputField,
    FracField
  },
  data() {
    return {
      model: [
        //{type:"atom-single-bonding", position:{x:0, y:0, z:0}, rotation:{x:0, y:0, z:0}},
        //{type:"atom-single-bonding", position:{x:0, y:0, z:0}, rotation:{x:0, y:0, z:0}},
        //{type:"lone-electron", position:{x:0, y:0, z:0}, rotation:{x:0, y:0, z:0}}
        //<math><msup><mi>x</mi><mn>2</mn></msup><mo>+</mo><mn>5</mn><mi>x</mi><mo>+</mo><mn>4</mn></math>
        //<math><mn>4</mn><msup><mi>x</mi><mn>2</mn></msup><mo>-</mo><mn>8</mn><mi>x</mi><mo>+</mo><mn>4</mn></math>
        //<math><mn>4</mn><msup><mi>x</mi><mn>2</mn></msup><mo>-</mo><mn>20</mn><mi>x</mi><mo>+</mo><mn>24</mn></math>
        //<math><mo>-</mo><mn>7</mn><msup><mi>x</mi><mn>2</mn></msup><mo>+</mo><mn>28</mn><mi>x</mi><mo>-</mo><mn>28</mn></math>
        //<math><mn>8</mn><msup><mi>x</mi><mn>2</mn></msup><mo>-</mo><mn>7</mn><mi>x</mi><mo>+</mo><mn>5</mn></math>
        //<math><msup><mi>x</mi><mn>2</mn></msup><mo>+</mo><mn>3</mn></math>
      ],
      exercise: {
        order: [
          {d:'Wyznacz postać iloczynową funkcji: <math><mi>f</mi><mo>(</mo><mi>x</mi><mo>)</mo><mo>=</mo><msup><mi>x</mi><mn>2</mn></msup><mo>+</mo><mn>5</mn><mi>x</mi><mo>+</mo><mn>4</mn></math>', model:[5,1,4,9,-5,9,1,-1,-5,9,1,-4,null,null,null,1,'+1','+4',null,null], id:0},
          {d:'Wyznacz postać iloczynową funkcji: <math><mi>f</mi><mo>(</mo><mi>x</mi><mo>)</mo><mo>=</mo><mn>4</mn><msup><mi>x</mi><mn>2</mn></msup><mo>-</mo><mn>8</mn><mi>x</mi><mo>+</mo><mn>4</mn></math>', model:[-8,4,4,0,null,null,null,null,null,null,null,null,8,4,1,null,null,null,4,-1], id:0},
          {d:'Wyznacz postać iloczynową funkcji: <math><mi>f</mi><mo>(</mo><mi>x</mi><mo>)</mo><mo>=</mo><mn>4</mn><msup><mi>x</mi><mn>2</mn></msup><mo>-</mo><mn>20</mn><mi>x</mi><mo>+</mo><mn>24</mn></math>', model:[-20,4,24,16,20,16,4,3,20,16,4,2,null,null,null,4,-3,-2,null,null], id:0},
          {d:'Wyznacz postać iloczynową funkcji: <math><mi>f</mi><mo>(</mo><mi>x</mi><mo>)</mo><mo>=</mo><mo>-</mo><mn>7</mn><msup><mi>x</mi><mn>2</mn></msup><mo>+</mo><mn>28</mn><mi>x</mi><mo>-</mo><mn>28</mn></math>', model:[28,-7,-28,0,null,null,null,null,null,null,null,null,-28,-7,2,null,null,null,-7,-2], id:0},
          {d:'Wyznacz postać iloczynową funkcji: <math><mi>f</mi><mo>(</mo><mi>x</mi><mo>)</mo><mo>=</mo><mn>8</mn><msup><mi>x</mi><mn>2</mn></msup><mo>-</mo><mn>7</mn><mi>x</mi><mo>+</mo><mn>5</mn></math>', model:[-7,8,5,-111], id:0},
          {d:'Wyznacz postać iloczynową funkcji: <math><mi>f</mi><mo>(</mo><mi>x</mi><mo>)</mo><mo>=</mo><msup><mi>x</mi><mn>2</mn></msup><mo>+</mo><mn>3</mn></math>', model:[0,1,3,-12], id:0},
        ],
        range: [{f:0, t:3},{f:4, t:14},{f:15, t:19}],
        steps: [1,[0,0,0],[0,0,0]],
        step: 0,
        currentCompleted: false,
        current: 0,
        operationToDo: true,
        /*feedback: {
          current: '',
          correct: {h:'Brawo!', d:'Model został wykonany prawidłowo.', i:'', p:1},
          incorrect: {h:'Niestety model nie został wykonany prawidłowo.', d:'Zapoznaj się z prawidłowym modelem na grafice obok i przypomnij sobie podstawy teoretyczne.', p:0}
        },*/
        points: 0,
        time: {current: 0, total: 60},
      },
      inputs: {components:[], values:[]},  
      //openModal: false,
      //openResultsModal: false
    };
  },
  beforeMount() {
    ArrayUtils.shuffle(this.exercise.order)
    this.exercise.current = 0
  },
  mounted() {
    timer.start()
    //console.log('TIMER', timer)
    ///this.render()
    for (const property in this.$refs) {
      this.inputs.components = this.inputs.components.concat(this.$refs[property].getComponent())
    }
    //console.log('INPUTS', this.inputs.components)
  },
  watch: {
    
  },
  computed: {
    
  },
  methods: {
    checkModel: function() {
      //console.log("HOME IN", this.$refs)
      
      let isCorrect = this.checkStep()
      //console.log("STEP CORRECT:", isCorrect, this.exercise.step)//, this.exercise.step, this.inputs.values[3], (this.exercise.step+1), this.inputs.values)
      if(isCorrect) {
        switch(this.exercise.step) {
          case 0:
            this.exercise.step = 1
            if(this.inputs.values[3] > 0) {
              //this.exercise.steps[this.exercise.step+1][0] = 1//[1,0,0]
              Vue.set(this.exercise.steps[this.exercise.step], 0, 1)
            } else if(this.inputs.values[3] == 0) {
              //this.exercise.steps[this.exercise.step+1][1] = 1//[0,1,0]
              Vue.set(this.exercise.steps[this.exercise.step], 1, 1)
            } else {
              //this.exercise.steps[this.exercise.step+1][2] = 1//[0,0,1]
              Vue.set(this.exercise.steps[this.exercise.step], 2, 1)
              this.exercise.operationToDo = false
            }
            break;
          case 1:
            this.exercise.step = 2
            if(this.inputs.values[3] > 0) {
              //this.exercise.steps[this.exercise.step+1][0] = 1//[1,0,0]
              Vue.set(this.exercise.steps[this.exercise.step], 0, 1)
            } else if(this.inputs.values[3] == 0) {
              //this.exercise.steps[this.exercise.step+1][1] = 1//[0,1,0]
              Vue.set(this.exercise.steps[this.exercise.step], 1, 1)
            } else {
              //this.exercise.steps[this.exercise.step+1][2] = 1//[0,0,1]
              Vue.set(this.exercise.steps[this.exercise.step], 2, 1)
              //wygas przycisk sprawdz i daj nowe zadanie
              this.exercise.currentCompleted = true
              this.exercise.operationToDo = true
            } 
            //this.step = 2
            break;
          case 2:
            //wygas przycisk sprawdz i daj nowe zadanie
            this.exercise.currentCompleted = true
            break;   
          case 3:
              
            break;  
          default:
            break;
        }
      }
      ///this.openModal = true

      timer.stop()
      this.exercise.time.current = timer.getTimeMMSS()
      //console.log("TT", timer.getTimeMMSS())
      this.womiSize()
    },
    checkStep: function() {
      this.inputs.values = []
      for (const property in this.$refs) {
        this.inputs.values = this.inputs.values.concat(this.$refs[property].getValue())//Array.isArray(this.$refs[property].getValue()) ? this.$refs[property].getValue() : [this.$refs[property].getValue()])
      }
      //console.log("H VLS", this.inputs);
      
      let isCorrect = true
      for(var i=this.exercise.range[this.exercise.step].f; i<=this.exercise.range[this.exercise.step].t; i++) {
        //console.log("FIELDS CHECK:", this.exercise.order[this.exercise.current].model[i], this.inputs.values[i])
        this.inputs.components[i].$el.classList.remove("correct", "incorrect")
        //zeby dalej bylo łatwiej porownać model z pustym polem
        if(this.exercise.order[this.exercise.current].model[i] == null) this.exercise.order[this.exercise.current].model[i] = ""

        if(this.exercise.order[this.exercise.current].model[i].toString() == this.inputs.values[i]){
          this.inputs.components[i].$el.classList.add("correct", "disabled")
        } else {
          this.inputs.components[i].$el.classList.add("incorrect")
          isCorrect = false
        }

        /*if(isNaN(this.exercise.order[this.exercise.current].model[i]) && isNaN(this.inputs.values[i])) {
          //
        } else if(this.exercise.order[this.exercise.current].model[i] == this.inputs.values[i]) {
          if(this.exercise.order[this.exercise.current].model[i] != null && this.inputs.values[i]) {
            this.inputs.components[i].$el.classList.add("correct", "disabled")
          } else {
            this.inputs.components[i].$el.classList.add("incorrect")
            isCorrect = false
          }
        } else {
          this.inputs.components[i].$el.classList.add("incorrect")
          isCorrect = false
        }*/
      }

      if(isCorrect) {
        for(var i=0; i<this.inputs.components.length; i++) {
          this.inputs.components[i].$el.classList.remove("correct", "incorrect")
        }
      }
      return isCorrect
    },
    nextModel: function() {
      //this.resetExercise()
      for(var i=0; i<this.inputs.components.length; i++) {
        //console.log("IN ", this.inputs.components[i])
        this.inputs.components[i].setValue("")
        this.inputs.components[i].$el.classList.remove("disabled", "correct", "incorrect")
      }
      this.exercise.currentCompleted = false
      this.exercise.steps = [1,[0,0,0],[0,0,0]]
      this.exercise.step = 0
      this.exercise.operationToDo = true
      this.exercise.current += 1      
      if(this.exercise.current > this.exercise.order.length - 1) {
        this.exercise.current = 0
      }
      timer.reset()
      timer.start()
      setTimeout(this.womiSize, 100)
    },
    womiSize() {
      this.$nextTick(()=>{
        //console.log("CHANGE SIZE ", document.querySelector('#app').scrollHeight)
        if(window.frameElement) {
          window.frameElement.style.height = document.querySelector('#app').scrollHeight+'px'
        }
      })
    }
    /*confirmModal: function() {
      this.openModal = false
    },*/
    /*newTask: function() {
      this.openModal = false
      //this.resetExercise()
      this.exercise.current += 1
      timer.start()
    },*/
    /*exerciseSummary: function() {
      this.openModal = false
      this.openResultsModal = true
    },*/
    /*resetExercise: function() {
      this.intersected = null
      this.model = []
      //timer.reset() // reset dopiero na sam koniec
    },*/
    /*startExercise: function() {
      timer.reset()
      this.resetExercise()
      ///ArrayUtils.shuffle(this.exercise.order)
      this.exercise.points = 0
      this.exercise.current = 0
      //this.openResultsModal = false
    }*/
  }
  
})
export default class Home extends Vue {}
